import React from 'react';
import { Grid3x3 } from 'lucide-react';
import { useAnalisis } from './useAnalisis';
import { PanelAnalisis } from './PanelAnalisis';

const DIAS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

const color = (n, max) => {
  if (!n) return '#f1f5f9';
  const t = Math.min(1, n / (max || 1));
  const l = 92 - t * 62;
  return `hsl(199, 89%, ${l}%)`;
};

// Nivel 0-5 para el respaldo con clases (el overlay del preview transparenta los fondos inline).
const nivel = (n, max) => (n ? Math.max(1, Math.ceil(Math.min(1, n / (max || 1)) * 5)) : 0);

// D4 / F3: grilla 7 días x 24 horas con la cantidad de movimientos, coloreada por intensidad.
export const MapaHorarios = ({ cuit, casoId, episodioId, desde, hasta }) => {
  const { data, loading, error } = useAnalisis({ cuit, casoId, episodioId, desde, hasta });
  const h = data?.horarios;
  return (
    <PanelAnalisis titulo="Mapa de horarios (día x hora)" icono={Grid3x3} testid="mapa-horarios"
      loading={loading} error={error}
      vacio={h && !h.total ? 'Sin movimientos en el período'
        : h && h.total === h.sin_hora ? 'Los movimientos del período son de la base histórica, que no guarda la hora' : null}
      extra={h ? (
        <span className="text-xs text-slate-400" data-testid="mapa-horarios-total">
          {h.total} movimientos{h.sin_hora ? ` · ${h.sin_hora} sin hora (base histórica)` : ''}
        </span>
      ) : null}>
      {h && (
        <div className="overflow-x-auto">
          <div className="inline-grid min-w-full gap-[3px]" style={{ gridTemplateColumns: '40px repeat(24, minmax(18px, 1fr))' }}>
            <span />
            {Array.from({ length: 24 }, (_, i) => (
              <span key={i} className="text-center text-[9px] text-slate-400">{String(i).padStart(2, '0')}</span>
            ))}
            {h.grilla.map((fila, d) => (
              <React.Fragment key={d}>
                <span className="pr-1 text-right text-[11px] font-medium leading-[18px] text-slate-500">{DIAS[d]}</span>
                {fila.map((n, hora) => (
                  <span key={hora} title={`${DIAS[d]} ${String(hora).padStart(2, '0')}:00 → ${n} movimientos`}
                    data-testid={`mapa-celda-${d}-${hora}`}
                    data-nivel={nivel(n, h.maximo)}
                    className="mapa-celda h-[18px] rounded-[3px] transition-transform duration-150 hover:scale-125"
                    style={{ backgroundColor: color(n, h.maximo) }} />
                ))}
              </React.Fragment>
            ))}
          </div>
          <div className="mt-3 flex items-center gap-2 text-[10px] text-slate-400">
            <span>Menos</span>
            {[0, 0.25, 0.5, 0.75, 1].map((t) => (
              <span key={t} data-nivel={nivel(t * (h.maximo || 1), h.maximo || 1)} className="mapa-celda h-3 w-5 rounded-sm"
                style={{ backgroundColor: color(t * (h.maximo || 1), h.maximo || 1) }} />
            ))}
            <span>Más (máx. {h.maximo})</span>
          </div>
        </div>
      )}
    </PanelAnalisis>
  );
};

export default MapaHorarios;
